<template>
	<!-- Register Section -->		
	<div class="login-content">
	  <div class="container">
		<div class="row">
		  <div class="col-md-6 col-lg-5 mx-auto">
			<div class="login-wrap register-form">
			  
			  <div class="login-header">
				<h3>Create an Account</h3>
				<p>Let's start with <span>Listee</span></p>								
			  </div>
			  
			  <!-- Register Form -->
			  <b-form @submit.prevent="registerUser">
				<div class="form-group group-img">
				  <div class="group-img">
					<i class="feather-user"></i>
					<b-form-input type="text" class="form-control" placeholder="Full Name" v-model="user.name" />
				  </div>
				</div>
				<div class="form-group group-img">
				  <div class="group-img">
					<i class="feather-mail"></i>
					<b-form-input type="text" class="form-control" placeholder="Email Address" v-model="user.email" />
				  </div>
				</div>
				<div class="form-group group-img">
				  <div class="group-img">
					<i class="feather-lock"></i>
					<b-form-input type="password" class="form-control" placeholder="Password" v-model="user.password" />
				  </div>
				</div>
				<div class="form-group group-img">
				  <div class="group-img">
					<i class="feather-lock"></i>
					<b-form-input type="password" class="form-control" placeholder="Confirm Password" v-model="user.password_confirmation" />
				  </div>
				</div>
				<b-button variant="primary w-100 login-btn" type="submit">Create Account</b-button>
				<div class="register-link text-center">
				  <p>Already have an account? <router-link class="forgot-link" to="/login">Sign In</router-link></p>
				</div>
				<div class="login-or">
				  <span class="or-line"></span>
				  <span class="span-or">Sign in with Social Media Accounts</span>
				</div>					
				<div class="social-login">
				  <a href="#" class="btn btn-apple w-100"><img src="../../../assets/img/apple.svg" class="me-1" alt="img">Sign in with Apple</a>
				</div>
				<div class="social-login">
				  <a href="#" class="btn btn-google w-100"><img src="../../../assets/img/google.svg" class="me-1" alt="img">Sign in with Google</a>
				</div>
				<div class="social-login">
				  <a href="#" class="btn btn-facebook w-100 mb-0"><img src="../../../assets/img/facebook.svg" class="me-2" alt="img">Continue with Facebook</a>
				</div>								
			  </b-form>
			  <!-- /Register Form -->
											  
			</div>
		  </div>
		</div>
		
	  </div>
	</div>
	<!-- /Register Section -->
  </template>
  
  <script>
  import { register } from '@/services/authService';
  import Swal from 'sweetalert2';
  import router from '@/router/index';

  
  export default {
	data() {
	  return {
		showPassword: false,
		user: {
		  name: '',
		  email: '',
		  password: '',
		  password_confirmation: ''
		},
	  };
	},
	computed: {
	  buttonLabel() {
		return this.showPassword ? "Hide" : "Show";
	  },
	},
	methods: {
	  toggleShow() {
		this.showPassword = !this.showPassword;
	  },
	  async registerUser() {
		try {
		  const response = await register(this.user);
		  // Traitement de la réponse (redirection, affichage de message, etc.)
		  Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Your account has been created successfully!',
        }).then(() => {
          // Redirection vers /dashboard après la confirmation de l'alerte
          //this.$router.push('/dashboard');

        });
		} catch (error) {
		  // Gestion des erreurs (affichage de message d'erreur, etc.)
		  console.error(error);
		}
	  },
	},
  };
  </script>
  